import React, { useEffect } from 'react';

import {
  Flex, GridItem, Table, Tbody, Td, Text, Th, Thead, Tr,
} from '@chakra-ui/react';
import { useSpring, animated } from 'react-spring';

function Item({ name, performedActivities }) {
  const AnimatedText = animated(Text);

  const [style, inc] = useSpring(() => ({
    x: 0,
  }));

  useEffect(() => {
    inc({ x: performedActivities });
  }, [performedActivities]);

  return (
    <Tr>
      <Td>
        <Text
          variant="xSmallRegular"
          color="gray.500">
          {name}
        </Text>
      </Td>
      <Td isNumeric>
        <Flex
          justify="flex-end">
          <AnimatedText
            variant="xSmallBold"
            color="gray.500">{style.x.to((x) => x.toFixed(0))}
          </AnimatedText>
        </Flex>
      </Td>
    </Tr>
  );
}

export default function ActivitiesPerPartnerCard({ data = [] }) {
  return (
    <GridItem
      as={Flex}
      bg="white.default"
      color="gray.50"
      flexDir="column"
      borderRadius={8}
      colSpan={3}>
      <Flex
        p={2}
        alignItems="center"
        justifyContent="space-between"
        borderBottom="1px">
        <Text
          variant="xSmallBold"
          color="gray.600">
          Atividades de Clientes
        </Text>
      </Flex>
      <Flex
        width="100%"
        p={4}>
        <Flex
          overflow="scroll"
          height={200}
          width="100%">
          <Table
            size="sm"
            variant="unstyled">
            <Thead bg="gray.50">
              <Tr>
                <Th>
                  <Text
                    color="gray.600"
                    variant="xSmallSemiBold">
                    Cliente
                  </Text>
                </Th>
                <Th isNumeric>
                  <Flex
                    justify="flex-end">
                    <Text
                      color="gray.600"
                      variant="xSmallSemiBold">
                      Atividades
                    </Text>
                  </Flex>
                </Th>
              </Tr>
            </Thead>
            <Tbody>
              {data.map((activity) => <Item {...activity} />)}
            </Tbody>
          </Table>
        </Flex>
      </Flex>
    </GridItem>
  );
}
